import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
  Jaarrekening, Jaarrapportage
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {Observable, ReplaySubject, Subject, takeUntil} from "rxjs";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import {
  SpecFormattedexplanationpolicyComponent
} from '../spec-formattedexplanationpolicy/spec-formattedexplanationpolicy.component';


@Component({
  selector: 'snelstart-venture-fiscaal-feature-grondslagen-algemeen',
  templateUrl: './grondslagen-algemeen.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecFormattedexplanationpolicyComponent
],
  styleUrls: ['./grondslagen-algemeen.component.scss']
})
export class GrondslagenAlgemeenComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  public showCustomControls = true;
  public index = 0;
  public dialogVisible = false;
  public clientEntity = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public heeftAandelen = false;
  public isCooperatie= false;
  public selectedTab = 0;
  public accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg = {} as FormGroup;
  public noChangesInAccountingPoliciesDescriptionFg = {} as FormGroup;
  public functionalCurrencyDescriptionFg = {} as FormGroup; // is selectable
  public foreignCurrencyTranslationPolicyFg = {} as FormGroup;
  public foreignCurrencyTranslationBalanceSheetPolicyFg = {} as FormGroup;
  public operatingLeasesPolicyFg = {} as FormGroup;
  public financeLeasesPolicyFg = {} as FormGroup;
  public exceptionalItemsPolicyFg = {} as FormGroup;
  public leasesPolicyFg = {} as FormGroup;
  public pensionArrangementsPolicyFg = {} as FormGroup;
  public differenceFiscalCommercialAccountingPrinciplesDisclosureFg = {} as FormGroup;
  public accountingStandardsAppliedEarlierDescriptionFg = {} as FormGroup;
  public fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg = {} as FormGroup;
  public historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg = {} as FormGroup;
  public determinationCostPriceIndirectCostsDescriptionFg = {} as FormGroup;
  public relatedPartyTransactionsPolicyFg = {} as FormGroup;
  public changeAccountingEstimatesExplanationFg = {} as FormGroup;
  public changeAccountingPoliciesDisclosureFg = {} as FormGroup;
  public priorPeriodErrorsDisclosureFg = {} as FormGroup;
  public shareBasedPaymentsPolicyFg = {} as FormGroup;
  public financialInstrumentsPolicyFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Keuze actief"},
    {value: false, label: "Keuze niet actief"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  private destroy$ = new Subject<void>();

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService) {
    this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.noChangesInAccountingPoliciesDescriptionFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.functionalCurrencyDescriptionFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.foreignCurrencyTranslationPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.foreignCurrencyTranslationBalanceSheetPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.operatingLeasesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.financeLeasesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.exceptionalItemsPolicyFg  = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.leasesPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.pensionArrangementsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.accountingStandardsAppliedEarlierDescriptionFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.determinationCostPriceIndirectCostsDescriptionFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.relatedPartyTransactionsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.changeAccountingEstimatesExplanationFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.changeAccountingPoliciesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.priorPeriodErrorsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.shareBasedPaymentsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
    this.financialInstrumentsPolicyFg = this.jrDataService.createFormGroupFormattedExplanationPolicy();
  }

  ngOnInit(): void {

    this.algDataService.client.subscribe((value) => {
      this.clientEntity = value;
    });
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    });
    this.jrDataService.isCooperatie.subscribe((value) => {
      this.isCooperatie = value;
    });
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
          this.selectedTab = tab
        });
    }

    this.jrDataService.jaarrapportageEntity.pipe(takeUntil(this.destroy$)).subscribe((jrEntity) => {
      this.jrEntity = jrEntity;
      this.patchData(jrEntity);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private patchData(value: JaarrapportageEntity) {
    const text = value.rapportage?.jaarrekeningen?.at(0)?.toelichting?.algemeneGrondslagen;
    if (text) {
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.accountingStandardsUsedToPrepareFinancialStatementsDescription) {
        this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.accountingStandardsUsedToPrepareFinancialStatementsDescription);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.noChangesInAccountingPoliciesDescription) {
        this.noChangesInAccountingPoliciesDescriptionFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.noChangesInAccountingPoliciesDescription);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.functionalCurrencyDescription) {
        this.functionalCurrencyDescriptionFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.functionalCurrencyDescription);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.differenceFiscalCommercialAccountingPrinciplesDisclosure) {
        this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.differenceFiscalCommercialAccountingPrinciplesDisclosure);
      }
      if (text.omrekeningVreemdeValuta?.omrekeningVreemdeValutaTekstueel?.foreignCurrencyTranslationPolicy) {
        this.foreignCurrencyTranslationPolicyFg.patchValue(text.omrekeningVreemdeValuta?.omrekeningVreemdeValutaTekstueel?.foreignCurrencyTranslationPolicy);
      }
      if (text.omrekeningVreemdeValuta?.omrekeningVreemdeValutaTekstueel?.foreignCurrencyTranslationBalanceSheetPolicy) {
        this.foreignCurrencyTranslationBalanceSheetPolicyFg.patchValue(text.omrekeningVreemdeValuta?.omrekeningVreemdeValutaTekstueel?.foreignCurrencyTranslationBalanceSheetPolicy);
      }
      if (text.leases?.leasesTekstueel?.leasesPolicy) {
        this.leasesPolicyFg.patchValue(text.leases?.leasesTekstueel?.leasesPolicy);
      }
      if (text.leases?.leasesTekstueel?.financeLeasesPolicy) {
        this.financeLeasesPolicyFg.patchValue(text.leases?.leasesTekstueel?.financeLeasesPolicy);
      }
      if (text.leases?.leasesTekstueel?.operatingLeasesPolicy) {
        this.operatingLeasesPolicyFg.patchValue(text.leases?.leasesTekstueel?.operatingLeasesPolicy);
      }
      if (text.bijzonderePosten?.bijzonderePostenAlgemeneGrondslagenTekstueel?.exceptionalItemsPolicy) {
        this.exceptionalItemsPolicyFg.patchValue(text.bijzonderePosten?.bijzonderePostenAlgemeneGrondslagenTekstueel?.exceptionalItemsPolicy);
      }
      if (text.pensioenregelingen?.pensioenregelingenTekstueel?.pensionArrangementsPolicy) {
        this.pensionArrangementsPolicyFg.patchValue(text.pensioenregelingen?.pensioenregelingenTekstueel?.pensionArrangementsPolicy);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.accountingStandardsAppliedEarlierDescription) {
        this.accountingStandardsAppliedEarlierDescriptionFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.accountingStandardsAppliedEarlierDescription);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosure) {
        this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosure);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.historicalCostInformationWhenPreparedOnFairValueBasisDisclosure) {
        this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.historicalCostInformationWhenPreparedOnFairValueBasisDisclosure);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.determinationCostPriceIndirectCostsDescription) {
        this.determinationCostPriceIndirectCostsDescriptionFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.determinationCostPriceIndirectCostsDescription);
      }
      if (text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.relatedPartyTransactionsPolicy) {
        this.relatedPartyTransactionsPolicyFg.patchValue(text.algemeen?.algemeneGrondslagenAlgemeenTekstueel?.relatedPartyTransactionsPolicy);
      }
      if (text.schattingswijzigingen?.schattingswijzigingenTekstueel?.changeAccountingEstimatesExplanation) {
        this.changeAccountingEstimatesExplanationFg.patchValue(text.schattingswijzigingen?.schattingswijzigingenTekstueel?.changeAccountingEstimatesExplanation);
      }
      if (text.stelselwijzigingen?.stelselwijzigingenTekstueel?.changeAccountingPoliciesDisclosure) {
        this.changeAccountingPoliciesDisclosureFg.patchValue(text.stelselwijzigingen?.stelselwijzigingenTekstueel?.changeAccountingPoliciesDisclosure);
      }
      if (text.foutherstel?.foutherstelTekstueel?.priorPeriodErrorsDisclosure) {
        this.priorPeriodErrorsDisclosureFg.patchValue(text.foutherstel?.foutherstelTekstueel?.priorPeriodErrorsDisclosure);
      }
      if (text.opAandelenGebaseerdeBetalingen?.opAandelenGebaseerdeBetalingenAlgemeneGrondslagenTekstueel?.shareBasedPaymentsPolicy) {
        this.shareBasedPaymentsPolicyFg.patchValue(text.opAandelenGebaseerdeBetalingen?.opAandelenGebaseerdeBetalingenAlgemeneGrondslagenTekstueel?.shareBasedPaymentsPolicy);
      }
      if (text.financieleInstrumenten?.financieleInstrumentenTekstueel?.financialInstrumentsPolicy) {
        this.financialInstrumentsPolicyFg.patchValue(text.financieleInstrumenten?.financieleInstrumentenTekstueel?.financialInstrumentsPolicy);
      }
    }
  }

  saveForm(): void {
    this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.noChangesInAccountingPoliciesDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.functionalCurrencyDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.foreignCurrencyTranslationPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.foreignCurrencyTranslationBalanceSheetPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.operatingLeasesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.financeLeasesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.exceptionalItemsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.leasesPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.pensionArrangementsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.accountingStandardsAppliedEarlierDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.determinationCostPriceIndirectCostsDescriptionFg.updateValueAndValidity({ emitEvent: false });
    this.relatedPartyTransactionsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.changeAccountingEstimatesExplanationFg.updateValueAndValidity({ emitEvent: false });
    this.changeAccountingPoliciesDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.priorPeriodErrorsDisclosureFg.updateValueAndValidity({ emitEvent: false });
    this.shareBasedPaymentsPolicyFg.updateValueAndValidity({ emitEvent: false });
    this.financialInstrumentsPolicyFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        toelichting: {
          ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting,
          algemeneGrondslagen: {
            ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen,
            algemeen: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.algemeen,
              algemeneGrondslagenAlgemeenTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.algemeen?.algemeneGrondslagenAlgemeenTekstueel,
                accountingStandardsUsedToPrepareFinancialStatementsDescription: this.accountingStandardsUsedToPrepareFinancialStatementsDescriptionFg.value,
                noChangesInAccountingPoliciesDescription: this.noChangesInAccountingPoliciesDescriptionFg.value,
                differenceFiscalCommercialAccountingPrinciplesDisclosure: this.differenceFiscalCommercialAccountingPrinciplesDisclosureFg.value,
                functionalCurrencyDescription: this.functionalCurrencyDescriptionFg.value,
                accountingStandardsAppliedEarlierDescription: this.accountingStandardsAppliedEarlierDescriptionFg.value,
                fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosure: this.fairValueInformationWhenPreparedOnHistoricalCostBasisDisclosureFg.value,
                historicalCostInformationWhenPreparedOnFairValueBasisDisclosure: this.historicalCostInformationWhenPreparedOnFairValueBasisDisclosureFg.value,
                determinationCostPriceIndirectCostsDescription: this.determinationCostPriceIndirectCostsDescriptionFg.value,
                relatedPartyTransactionsPolicy: this.relatedPartyTransactionsPolicyFg.value
              }
            },
            omrekeningVreemdeValuta: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.omrekeningVreemdeValuta,
              omrekeningVreemdeValutaTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.omrekeningVreemdeValuta?.omrekeningVreemdeValutaTekstueel,
                foreignCurrencyTranslationPolicy: this.foreignCurrencyTranslationPolicyFg.value,
                foreignCurrencyTranslationBalanceSheetPolicy: this.foreignCurrencyTranslationBalanceSheetPolicyFg.value,
              }
            },
            leases: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.leases,
              leasesTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.leases?.leasesTekstueel,
                leasesPolicy: this.leasesPolicyFg.value,
                financeLeasesPolicy: this.financeLeasesPolicyFg.value,
                operatingLeasesPolicy: this.operatingLeasesPolicyFg.value,
              }
            },
            bijzonderePosten: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.bijzonderePosten,
              bijzonderePostenAlgemeneGrondslagenTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.bijzonderePosten?.bijzonderePostenAlgemeneGrondslagenTekstueel,
                exceptionalItemsPolicy: this.exceptionalItemsPolicyFg.value
              }
            },
            pensioenregelingen: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.pensioenregelingen,
              pensioenregelingenTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.pensioenregelingen?.pensioenregelingenTekstueel,
                pensionArrangementsDescription: this.pensionArrangementsPolicyFg.value,
              }
            },
            schattingswijzigingen: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.schattingswijzigingen,
              schattingswijzigingenTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.schattingswijzigingen?.schattingswijzigingenTekstueel,
                changeAccountingEstimatesExplanation: this.changeAccountingEstimatesExplanationFg.value
              }
            },
            stelselwijzigingen: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.stelselwijzigingen,
              stelselwijzigingenTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.stelselwijzigingen?.stelselwijzigingenTekstueel,
                changeAccountingPoliciesDisclosure: this.changeAccountingPoliciesDisclosureFg.value
              }
            },
            foutherstel: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.foutherstel,
              foutherstelTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.foutherstel?.foutherstelTekstueel,
                priorPeriodErrorsDisclosure: this.priorPeriodErrorsDisclosureFg.value
              }
            },
            opAandelenGebaseerdeBetalingen: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.opAandelenGebaseerdeBetalingen,
              opAandelenGebaseerdeBetalingenAlgemeneGrondslagenTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.opAandelenGebaseerdeBetalingen?.opAandelenGebaseerdeBetalingenAlgemeneGrondslagenTekstueel,
                shareBasedPaymentsPolicy: this.shareBasedPaymentsPolicyFg.value,
              }
            },
            financieleInstrumenten: {
              ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.financieleInstrumenten,
              financieleInstrumentenTekstueel: {
                ...this.jrEntity.rapportage.jaarrekeningen[0].toelichting?.algemeneGrondslagen?.financieleInstrumenten?.financieleInstrumentenTekstueel,
                financialInstrumentsPolicy: this.financialInstrumentsPolicyFg.value,
              }
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
  }
}
